import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    el: ".js-video-modal",
    ui: {
        closeBtn: ".js-modal-close-button",
        playerWrap: ".js-video-wrap",
        playerIframe: ".js-video-wrap iframe"
    }
})

export default class ViewController extends Marionette.View<Backbone.Model>{

    constructor() {
        super();
    }

    // --------------------------------
    // events
    // --------------------------------

    @on("click @ui.closeBtn")
    onCloseModalBtnClick(JQueryEventObject: any) {
        const $closestVideoModal = $(JQueryEventObject.currentTarget).closest(".js-video-modal");
        const $thisVideoIframe = $closestVideoModal.find("iframe");
        this.stopVideo($thisVideoIframe);  
    }

    // --------------------------------
    // functions
    // --------------------------------

    onRender() {
        console.log("video modal viewcontroller rendered");
    }

    /**
     * ensure that video stops playing when video modal is closed
     */ 
    stopVideo($videoIframeToStop: any) {
        let videoSrc = $videoIframeToStop.attr("src");
        $videoIframeToStop.attr("src", "");
        $videoIframeToStop.attr("src", videoSrc);
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/video-modal/controller.ts